
/** The shipped currency word. `MONETARY_UNIT0` (`locale_game.txt:304`) is
 *  "Yang" -- the English pack contains no "gold" anywhere. */
export const MONETARY_UNIT = "Yang";

/** Digits of a whole, non-negative amount in groups of three. Empty for
 *  anything that is not a positive finite number, which is how both shipped
 *  spellings branch on `n <= 0`. */
function groups(value: number, separator: string): string {
  if (!Number.isFinite(value) || value <= 0) return "";
  const digits = String(Math.floor(value));
  const out: string[] = [];
  for (let end = digits.length; end > 0; end -= 3) {
    out.unshift(digits.slice(Math.max(0, end - 3), end));
  }
  return out.join(separator);
}

/** `NumberToMoneyString`'s digits without the unit, for the inventory board:
 *  it already draws `money_icon` (`inventorywindow.py:282-291`) and the text
 *  child is the amount only (`:293-304`). */
export function moneyAmount(value: number): string {
  return groups(value, ".") || "0";
}

/** `localeinfo.py:947-951` -- "1.234.567 Yang", never "1.23M" and never the
 *  word "gold"; `"0 Yang"` for zero or less (`:948-949`). */
export function formatYang(value: number): string {
  return `${moneyAmount(value)} ${MONETARY_UNIT}`;
}

/** The guild window's own override (`uiguild.py:30-35`): comma groups, no
 *  unit, `"0"` for zero or less. Used for the bank balance and for the three
 *  numbers in that panel which are money-shaped without being money. */
export function guildAmount(value: number): string {
  return groups(value, ",") || "0";
}

/** Money, shortened, for the places a full `formatYang` does not fit -- a
 *  32px sell badge, a shop row. Not a spelling the original has; the panels
 *  that print a price the way the source does use `formatYang`. */
export function money(value: number): string {
  if (!Number.isFinite(value) || value < 0) return "0";
  if (value < 100_000) return String(Math.floor(value));
  if (value < 1_000_000) return `${Math.floor(value / 1000)}k`;
  return `${(value / 1_000_000).toFixed(2)}M`;
}
